const isBool = bool => {
    return bool === true || bool === false;
};

export {isBool};
